import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form, Image, Card } from 'semantic-ui-react'
import AuthActions from '../../reducers/authReducer'
import Logo from '../../assets/images/muuve.png'

class LoginContainer extends Component {
  state = {
    email: '',
    password: '',
  }

  render() {
    const { login } = this.props
    const { email, password } = this.state

    return (
      <Card style={{ width: 400, margin: '0 auto', textAlign: 'left', padding: 40 }}>
        <Image
          src={Logo}
          size="small"
          style={{ margin: '0 auto', backgroundColor: 'transparent' }}
        />
        <Form onSubmit={() => login(this.state)}>
          <Form.Input
            label="Email"
            onChange={e => this.setState({ email: e.target.value })}
            value={email}
          />

          <Form.Input
            label="Password"
            type="password"
            onChange={e => this.setState({ password: e.target.value })}
            value={password}
          />

          <Form.Button style={{ width: '100%', marginTop: 15 }}>Login</Form.Button>
        </Form>
      </Card>
    )
  }
}

const mapDispatch = {
  login: AuthActions.login,
}

export default connect(
  null,
  mapDispatch
)(LoginContainer)



// WEBPACK FOOTER //
// ./src/containers/login/index.js